var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0.75C12.075 0.75 12.75 1.425 12.75 2.25H13.5C14.775 2.25 15.75 3.225 15.75 4.5V15C15.75 16.275 14.775 17.25 13.5 17.25H4.5C3.225 17.25 2.25 16.275 2.25 15V4.5C2.25 3.225 3.225 2.25 4.5 2.25H5.25C5.25 1.425 5.925 0.75 6.75 0.75H11.25ZM4.5 3.75C4.05 3.75 3.75 4.05 3.75 4.5V15C3.75 15.45 4.05 15.75 4.5 15.75H13.5C13.95 15.75 14.25 15.45 14.25 15V4.5C14.25 4.05 13.95 3.75 13.5 3.75H12.75C12.75 4.575 12.075 5.25 11.25 5.25H6.75C5.925 5.25 5.25 4.575 5.25 3.75H4.5ZM6.75 3.75H11.25V2.25H6.75V3.75Z",
    fill: "#82868B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_599_202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 14,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0.75C12.075 0.75 12.75 1.425 12.75 2.25H13.5C14.775 2.25 15.75 3.225 15.75 4.5V15C15.75 16.275 14.775 17.25 13.5 17.25H4.5C3.225 17.25 2.25 16.275 2.25 15V4.5C2.25 3.225 3.225 2.25 4.5 2.25H5.25C5.25 1.425 5.925 0.75 6.75 0.75H11.25ZM4.5 3.75C4.05 3.75 3.75 4.05 3.75 4.5V15C3.75 15.45 4.05 15.75 4.5 15.75H13.5C13.95 15.75 14.25 15.45 14.25 15V4.5C14.25 4.05 13.95 3.75 13.5 3.75H12.75C12.75 4.575 12.075 5.25 11.25 5.25H6.75C5.925 5.25 5.25 4.575 5.25 3.75H4.5ZM6.75 3.75H11.25V2.25H6.75V3.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_599_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#82868B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.3226ed077fc10f91fe301fd8c477c255.svg";
export { ForwardRef as ReactComponent };